export default __webpack_public_path__ + "static/media/PortalRight_Preview_Transparent.01da74e6.png";